import { useCallback } from 'react';

// 우측 상세 패널 가로폭 클램프 (월/주 공통)
export const PANEL_MIN_WIDTH = 300;
export const PANEL_MAX_WIDTH = 600;

/**
 * 패널 좌측 엣지 드래그로 가로폭 조절하는 훅.
 * 핸들 mouseDown 시 document 레벨로 move/up을 붙이고, 드래그 중 텍스트 선택을 막는다.
 */
export const usePanelResize = ({ width, onWidthChange }) => {
  return useCallback(
    e => {
      e.preventDefault();
      e.stopPropagation();
      const startX = e.clientX;
      const startWidth = width;

      const handleMove = moveEvent => {
        // 왼쪽으로 끌수록 패널이 넓어짐
        const next = Math.min(Math.max(startWidth + (startX - moveEvent.clientX), PANEL_MIN_WIDTH), PANEL_MAX_WIDTH);
        onWidthChange(next);
      };
      const handleUp = () => {
        document.removeEventListener('mousemove', handleMove);
        document.removeEventListener('mouseup', handleUp);
        document.body.style.userSelect = '';
        document.body.style.cursor = '';
      };

      document.body.style.userSelect = 'none'; // 드래그 중 텍스트 선택 방지
      document.body.style.cursor = 'col-resize';
      document.addEventListener('mousemove', handleMove);
      document.addEventListener('mouseup', handleUp);
    },
    [width, onWidthChange],
  );
};
